function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import { Modal, Grid } from 'semantic-ui-react';
import InlineSvg from './InlineSvg';
import LoadSVG from './LoadSVG';

var MobileNineDotMenu = function (_React$Component) {
  _inherits(MobileNineDotMenu, _React$Component);

  function MobileNineDotMenu() {
    _classCallCheck(this, MobileNineDotMenu);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  MobileNineDotMenu.prototype.render = function render() {
    var _props$products = this.props.products,
        products = _props$products === undefined ? [] : _props$products;
    return React.createElement(Modal, {
      trigger: React.createElement('button', {
        className: 'mobile-nine-dot-button'
      }, React.createElement(InlineSvg, {
        name: 'nineDot'
      })),
      closeIcon: React.createElement('button', {
        className: 'modal__close'
      }, 'Close')
    }, React.createElement(Modal.Header, null, 'Products'), React.createElement(Modal.Content, null, React.createElement(Grid, {
      columns: 3,
      className: 'mobile-nine-dot-menu'
    }, products.map(function (product) {
      var className = '';

      if (!product.hasAccess) {
        className += ' nine-dot__item--disabled';
      }

      return React.createElement(Grid.Column, {
        key: product.id
      }, React.createElement('a', {
        href: product.url,
        rel: 'noopener noreferrer',
        target: '_blank',
        className: className
      }, React.createElement('div', {
        className: 'mobile-nine-dot-menu__icon'
      }, React.createElement(LoadSVG, {
        colour: '#00a3c7',
        src: product.iconLogoLocation,
        alt: product.name
      })), React.createElement('span', null, product.name)));
    }))));
  };

  return MobileNineDotMenu;
}(React.Component);

export default MobileNineDotMenu;